module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "canvas",
    attrs: {
      "id": "canvas"
    }
  }, [_c('svg', {
    attrs: {
      "id": "north_axis",
      "height": "1792",
      "viewBox": "0 0 1792 1792",
      "width": "1792",
      "xmlns": "http://www.w3.org/2000/svg",
      "transform": ("rotate(" + _vm.northAxis + ")")
    }
  }, [_c('path', {
    attrs: {
      "d": "M1277 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9H800q-14 0-23-9t-9-23V512H544q-21 0-29-19t5-35L870 74q10-10 23-10 14 0 24 10l355 384q13 16 5 35z"
    }
  })]), _vm._v(" "), (_vm.mapEnabled) ? _c('map-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapVisible),
      expression: "mapVisible"
    }]
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-031586be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas/Canvas.vue
// module id = 666
// module chunks = 2